import React, { useEffect, useState } from 'react';
import { content, ContentType } from '../content/content';
import { statusRotation } from './statusRotation';
import { pollStatus } from './pollStatus';

const isDev = process.env.NODE_ENV === 'development';
const POLLING_INTERVAL = 2_500;
const TEXT_STATUS_INTERVAL = 5_000;
const WAIT_FOR_REDIRECT = 2_500;
const ENDPOINT = '/api/status';
const REDIRECT_PATH = '/vq/orders';

export const usePolling = ({ contentType }: { contentType: ContentType }) => {
  const [statusText, setStatusText] = useState(content[contentType].status.LOADING.text);
  const [ready, setReady] = useState(false);

  const setAsReady = () => {
    setReady(true);
    setStatusText(content[contentType].status.READY.text);
    setTimeout(() => {
      window.location.pathname = REDIRECT_PATH;
    }, WAIT_FOR_REDIRECT);
  };
  if (isDev) (window as any).setAsReady = setAsReady;

  useEffect(
    () =>
      statusRotation({
        setStatusText,
        textStatusInterval: TEXT_STATUS_INTERVAL,
        contentType,
      }),
    [],
  );

  useEffect(
    () =>
      pollStatus({
        endpoint: ENDPOINT,
        setAsReady,
        setStatusText,
        pollingInterval: POLLING_INTERVAL,
        contentType,
      }),
    [],
  );

  return { status: statusText, ready };
};
